/* eslint-disable */
function initAjaxForms() {
  $(document).ready(() => {
    // Alle Powermail-Formulare mit AJAX-Funktionalität selektieren
    const forms = document.querySelectorAll('form[data-powermail-ajax], .tx-powermail > form');
    forms.forEach(function(form) {
      const formUid = $(form).find('.powermail_form_uid').val();
      const modalId = 'modal-powermail-' + formUid;
      let bsModal;

      if ($('#'+ modalId).length === 0) {
        const modal = createFormModal(form, modalId);
        bsModal = new bootstrap.Modal(modal);
      } else {
        const modal = document.getElementById(modalId);
        bsModal = bootstrap.Modal.getInstance(modal);
      }

      const modalBody = document.querySelector('#'+ modalId +' .modal-body');

      form.addEventListener('submit', function(event) {
        event.preventDefault();

        if ($(form).find('.powermail-errors-list.filled').length > 0) {
          return;
        }

        $(form).find('button[type="submit"]').addClass('disabled').attr('disabled', 'disabled');

        // Formular per AJAX absenden
        fetch(form.getAttribute('action'), {
          method: 'POST',
          body: new FormData(form)
        })
          .then(response => response.text())
          .then(data => {
            // Response parsen
            const parser = new DOMParser();
            const htmlDocument = parser.parseFromString(data, 'text/html');
            const responseContent = htmlDocument.querySelector(`[data-powermail-form="${formUid}"]`);

            // Antwort im Modal anzeigen
            if (responseContent) {
              const $modalElm = $('#'+ modalId);
              modalBody.innerHTML = responseContent.outerHTML;
              if ($modalElm.find('table').length > 0) {
                $modalElm.children('.modal-dialog').removeClass('modal-sm');
              } else {
                $modalElm.children('.modal-dialog').addClass('modal-sm');
              }
              bsModal.show();

              $modalElm.find('input[data-powermail-form-ajax="confirmation"]').on('click', function(e) {
                e.preventDefault();
                bsModal.hide();
              });

              $modalElm.find('input[data-powermail-form-ajax="submit"]').on('click', function(e) {
                e.preventDefault();
                const submitForm = $(e.target)[0].closest('form');
                $(e.target).attr('disabled', 'disabled');

                // Formular per AJAX absenden
                fetch(submitForm.getAttribute('action'), {
                  method: 'POST',
                  body: new FormData(submitForm)
                })
                  .then(response => response.text())
                  .then(data => {
                    // Response parsen
                    const parser = new DOMParser();
                    const htmlDocument = parser.parseFromString(data, 'text/html');
                    const responseContent = htmlDocument.querySelector(`[data-powermail-form="${formUid}"]`);

                    // Antwort im Modal anzeigen
                    if (responseContent) {
                      modalBody.innerHTML = responseContent.outerHTML;
                      if ($modalElm.find('table').length > 0) {
                        $modalElm.children('.modal-dialog').removeClass('modal-sm');
                      } else {
                        $modalElm.children('.modal-dialog').addClass('modal-sm');
                      }
                      bsModal.show();
                    } else {
                      // modalBody.innerHTML = 'Ein Fehler ist aufgetreten.';
                    }
                  })
                  .catch(error => {
                    console.error('Fehler beim Absenden des Formulars:', error);
                    modalBody.innerHTML = 'Ein Fehler ist aufgetreten.';
                    bsModal.show();
                  });

              });

            } else {
              // no valid response
              // modalBody.innerHTML = 'Ein Fehler ist aufgetreten.';
              // bsModal.show();
            }

            $(form).find('button[type="submit"]').removeClass('disabled').removeAttr('disabled');
          })
          .catch(error => {
            console.error('Fehler beim Absenden des Formulars:', error);
            modalBody.innerHTML = 'Ein Fehler ist aufgetreten.';
            bsModal.show();
            $(form).find('button[type="submit"]').removeClass('disabled').removeAttr('disabled');
          });
      });
    });

    // Ext:forms formulare
    initExtFormsAjax();
  });
}


function initExtFormsAjax() {
  // version without .ajaxForm and modal from form template
  // const extForms = document.querySelectorAll('.frame-type-form_formframework form');const forms = document.querySelectorAll('.ajaxForm');
  const extForms = document.querySelectorAll('.ajaxForm');

  extForms.forEach(form => {
    // version without .ajaxForm and modal from form template
    // const formId = form.getAttribute('id');
    // const modalId = `modal-forms-${formId}`;
    // let bsModal;
    //
    // if ($('#'+ modalId).length === 0) {
    //   const formModal = createFormModal(form, modalId);
    //   bsModal = new bootstrap.Modal(formModal);
    // } else {
    //   const modal = document.getElementById(modalId);
    //   bsModal = bootstrap.Modal.getInstance(modal);
    // }
    //
    // const modalBody = document.querySelector('#'+ modalId +' .modal-body');

    const modal = $(form).siblings('.modal')[0];
    const modalBody = $(form).siblings('.modal').find('.modal-body')[0];
    const bsModal = bootstrap.Modal.getOrCreateInstance(modal);

    form.addEventListener('submit', function(event) {
      event.preventDefault();

      const frameContainerId = $(form).parents('.frame-container').first().attr('id');
      const submitButton = form.querySelector('button[type="submit"]');
      submitButton.disabled = true;

      // FormData Objekt erstellen
      const formData = new FormData(form);
      // AJAX Request URL mit typeNum für AJAX-Response
      const ajaxUrl = `${form.getAttribute('action')}`;

      fetch(ajaxUrl, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'

        }
      })
        .then(response => response.text())
        .then(data => {
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(data, 'text/html');
          const formContent = htmlDoc.querySelector('#'+ frameContainerId +' .ce-content');

          if (formContent) {
            let formInnerHtml = formContent.innerHTML;
            formInnerHtml = formInnerHtml.replaceAll('&lt;', '<').replaceAll('&gt;', '>');
            formInnerHtml = '<div class="form-success">'+ formInnerHtml +'</div>';
            modalBody.innerHTML = formInnerHtml;
            bsModal.show();
            form.reset();
          }

          submitButton.disabled = false;
        })
        .catch(error => {
          console.error('Fehler beim Formularversand:', error);
          modalBody.innerHTML = '<div class="alert alert-danger">Ein Fehler ist beim Versenden aufgetreten. Bitte versuchen Sie es später erneut.</div>';
          bsModal.show();
          submitButton.disabled = false;
        });

    });
  });
}

// helper function to create modal for ajax feedback
function createFormModal(form, modalId) {
  let modal = document.getElementById(modalId);
  if (modal) return modal;

  // Neues Modal erstellen
  modal = document.createElement('div');
  modal.className = 'modal fade';
  modal.id = modalId;
  modal.setAttribute('tabindex', '-1');
  modal.setAttribute('role', 'dialog');
  modal.innerHTML = `
    <div class="modal-dialog modal-sm modal-dialog-centered modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-inner">
          <button type="button" class="btn btn-secondary btn-close" data-bs-dismiss="modal" aria-label="Close modal"></button>
          <div class="modal-body"></div>
        </div>
      </div>
    </div>
  `;

  document.body.appendChild(modal);
  return modal;
}
